import CryptoJS from 'crypto-js';

export function encrypt(data) {
  const cypherText = CryptoJS.AES.encrypt(data, process.env.REACT_APP_CRYPTO_KEY).toString();
  return cypherText;
}

export function decrypt(data) {
  const bytes = CryptoJS.AES.decrypt(data, process.env.REACT_APP_CRYPTO_KEY);
  const decryptText = bytes.toString(CryptoJS.enc.Utf8);
  return decryptText;
}
